import { IconAlertCircle } from '@tabler/icons-react';

import {
    Accordion,
    Alert,
    MantineColor,
    Stack,
    Text,
    useComputedColorScheme
} from '@mantine/core';

interface AlertComponentProps {
    alertTitle: string;
    alertSummary?: string;
    details?: JSX.Element;
    color: MantineColor;
}

const AlertComponent = ({
    alertTitle,
    alertSummary,
    details,
    color
}: AlertComponentProps) => {
    const computedColorScheme = useComputedColorScheme('dark');
    const dark = computedColorScheme === 'dark';

    const textColor = dark ? 'gray.4' : 'black';
    return (
        <Alert
            icon={<IconAlertCircle size={'1rem'} stroke={1.5} />}
            title={alertTitle}
            color={color}
        >
            <Stack gap={'md'}>
                {alertSummary && <Text c={textColor}>{alertSummary}</Text>}
                {details != undefined && (
                    <Accordion
                        defaultValue='errorDetails'
                        chevronPosition='right'
                        variant='contained'
                    >
                        <Accordion.Item value='errorDetails'>
                            <Accordion.Control>
                                <Text fw={'500'}>Details</Text>
                            </Accordion.Control>
                            <Accordion.Panel>
                                <Stack gap={'md'} c={textColor}>
                                    {details}
                                </Stack>
                            </Accordion.Panel>
                        </Accordion.Item>
                    </Accordion>
                )}
            </Stack>
        </Alert>
    );
};

export const AlertError = ({
    summary,
    details
}: {
    summary?: string;
    details: JSX.Element;
}) => {
    return (
        <AlertComponent
            alertTitle={'Error'}
            color={'red'}
            alertSummary={summary}
            details={details}
        />
    );
};

export const AlertProblem = ({
    summary,
    details
}: {
    summary?: string;
    details: JSX.Element;
}) => {
    return (
        <AlertComponent
            alertTitle={'Problem'}
            color={'yellow'}
            alertSummary={summary}
            details={details}
        />
    );
};

export const AlertWarning = ({
    summary,
    details
}: {
    summary?: string;
    details?: JSX.Element;
}) => {
    return (
        <AlertComponent
            alertTitle={'Warning'}
            color={'yellow'}
            alertSummary={summary}
            details={details}
        />
    );
};
